package ru.dinarastepina.fabvocab.web.api

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import ru.dinarastepina.fabvocab.contracts.toDomain
import ru.dinarastepina.fabvocab.contracts.toDto
import ru.dinarastepina.fabvocab.domain.model.ExerciseResult
import ru.dinarastepina.fabvocab.domain.model.WordEntry
import ru.dinarastepina.fabvocab.domain.repository.WordRepository

class RemoteWordRepository(
    private val client: VocabularyApiClient,
) : WordRepository {
    private val _words = MutableStateFlow<List<WordEntry>>(emptyList())

    override fun observeWords(): Flow<List<WordEntry>> = _words.asStateFlow()

    override suspend fun getWord(id: String): WordEntry? {
        return client.getWord(id)?.toDomain()
    }

    override suspend fun fetchWord(word: String): WordEntry {
        return client.lookupWord(word).toDomain()
    }

    override suspend fun saveWord(entry: WordEntry): String {
        val response = client.saveWord(entry.toDto())
        refresh()
        return response.id
    }

    override suspend fun deleteWord(id: String) {
        client.deleteWord(id)
        refresh()
    }

    override suspend fun recordExerciseResult(result: ExerciseResult) {
        client.recordExerciseResult(result.wordId, result.exerciseType, result.wasCorrect)
    }

    override suspend fun getResultsForWord(wordId: String): List<ExerciseResult> {
        // Backend stats endpoint doesn't return full results list currently;
        // returning empty for now.
        return emptyList()
    }

    suspend fun refresh() {
        _words.value = client.getWords().map { it.toDomain() }
    }
}
